/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        29/12/2021 13:55
 * @copyright   Copyright (c) 2002-2021 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import * as MenuEnum from '../enumerators/MenuEnum'

export default class AutoHiddingNavAction {
    header = '[data-hc-trigger="hide-to-scroll"]'
    backtotop = '[data-trigger="wpiris-scroll"]'
    scrolling = false
    previousTop = 0
    currentTop = 0
    scrollDelta = 10
    scrollOffset = 50

    constructor() {
        $(window).on('scroll', () => {
            if (!$('body').hasClass(MenuEnum.MENU_IS_OPEN_CLASS)) {
                if (!this.scrolling) {
                    this.scrolling = true
                    if (!window.requestAnimationFrame) {
                        setTimeout(() => {
                            this.autoHideHeader()
                        }, 250)
                    } else {
                        requestAnimationFrame(() => {
                            this.autoHideHeader()
                        })
                    }
                }
            }
        })
    }

    autoHideHeader() {
        const currentTop = $(window).scrollTop()

        this.checkSimpleNavigation(currentTop)
        this.previousTop = currentTop
        this.scrolling = false
    }

    checkSimpleNavigation(currentTop) {
        if (this.previousTop - currentTop > this.scrollDelta) {
            $(this.header).removeClass('is-hidden')
        } else if (
            currentTop - this.previousTop > this.scrollDelta &&
            currentTop > this.scrollOffset
        ) {
            $(this.header).addClass('is-hidden')
        }

        if (currentTop > 0) {
            if (!$(this.header).hasClass('is-sticky') && $(this.header).hasClass('is-hidden')) {
                $(this.header).addClass('is-sticky')
            }
            if (!$(this.backtotop).hasClass('is-active')) {
                $(this.backtotop).addClass('is-active')
            }
        } else {
            $(this.header).removeClass('is-sticky')
            $(this.backtotop).removeClass('is-active')
        }
    }
}
